import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { ApplicationModule, RouteData } from '@shared/utils';

import { RouterUtilsService } from '../services/router-utils.service';
import { of } from 'rxjs';

/**
 * Sets currently active ApplicationModule
 */
@Injectable({
  providedIn: 'root',
})
export class RouterUtilsCanActivate {
  constructor(private _routerUtils: RouterUtilsService) {}

  canActivate(routeSnapshot: ActivatedRouteSnapshot): boolean {
    const data = routeSnapshot.data as RouteData;
    if (!data.applicationModule) console.warn('This route does not have data.applicationModule.');
    this._routerUtils.setActiveModule(data.applicationModule as ApplicationModule);
    return true;
  }
}

export const canActivateTeam: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return of(false);
};
